module.exports = __webpack_public_path__ + "img/ico-pcidss.6a8aff29.svg";